import { Component, Input, OnInit } from '@angular/core';
import { Shape, ListType, Sizes, SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})
export class ListComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-list-type') listType = ListType.AVATAR;
  // In case of Avatar List
  @Input('skc-show-img') showImg = false;
  @Input('skc-src-img') srcImg;
  @Input('skc-multi-lines') multiLines = true;
  currentImg;
  avatarImgSrc = 'assets/img/avatar.svg';

  // In case Bullet list
  @Input('skc-shape') shape = Shape.CIRCLE;
  @Input('skc-size') size: Sizes = Sizes.MIDDLE;
  @Input('skc-line-width') lineWidth = '100%';

  // In case of facebook or linkedin
  @Input('skc-border-radius') borderRadius = '0';
  @Input('skc-avatar-size') avatarSize: Sizes = Sizes.LARGE;
  @Input('skc-line-height') lineHeight: Sizes = Sizes.MIDDLE;
  enumListType = ListType;
  constructor() {
    super();
  }

  ngOnInit() {}
}
